import React from 'react';
import { Smartphone, Zap, Star, Shield } from 'lucide-react';

const Features = ({ language }) => {
  const texts = {
    en: {
      title: 'Why Choose Our Mobile App Hub?',
      subtitle: 'Experience the best mobile games and apps in one convenient place',
      features: [
        {
          icon: Smartphone,
          title: 'Wide Selection',
          description: 'Browse through hundreds of handpicked mobile games and essential apps for your device'
        },
        {
          icon: Zap,
          title: 'Fast Access',
          description: 'Quick and secure access with optimized speeds for instant availability of your favorites'
        },
        {
          icon: Star,
          title: 'Top Rated Content',
          description: 'Discover only the best-rated games and apps loved by millions of users worldwide'
        },
        {
          icon: Shield,
          title: 'Safe & Secure',
          description: 'All content is verified and safe, ensuring your device stays protected'
        }
      ]
    },
    sl: {
      title: 'Zakaj izbrati naš mobilni hub?',
      subtitle: 'Doživite najboljše mobilne igre in aplikacije na enem priročnem mestu',
      features: [
        {
          icon: Smartphone,
          title: 'Široka izbira',
          description: 'Prebrskajte med stotinami izbranih mobilnih iger in nujnih aplikacij za vašo napravo'
        },
        {
          icon: Zap,
          title: 'Hitri dostop',
          description: 'Hitri in varni dostop z optimizirano hitrostjo za takojšnjo dostopnost vaših najljubših'
        },
        {
          icon: Star,
          title: 'Najbolje ocenjene vsebine',
          description: 'Odkrijte samo najbolje ocenjene igre in aplikacije, ki jih ljubijo milijoni uporabnikov po vsem svetu'
        },
        {
          icon: Shield,
          title: 'Varno in zaščiteno',
          description: 'Vsa vsebina je preverjena in varna, kar zagotavlja zaščito vaše naprave'
        }
      ]
    }
  };

  const t = texts[language];

  return (
    <section id="section-2" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center mb-6">
                <feature.icon className="w-8 h-8 text-white" />
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Features Preview Image */}
        <div className="mt-20 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-indigo-600/20 rounded-3xl blur-3xl transform scale-110"></div>
          <div className="relative bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl p-8 shadow-2xl">
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src="/images/mobile-games-grid.jpeg"
                alt={language === 'en' ? 'Mobile games grid and app icons' : 'Mreža mobilnih iger in ikon aplikacij'}
                className="w-full h-auto rounded-2xl transform hover:scale-105 transition-transform duration-700"
              />
              
              {/* Overlay badges */}
              <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-lg">
                <div className="flex items-center space-x-2">
                  <Star className="w-5 h-5 text-yellow-500 fill-yellow-500" />
                  <span className="text-sm font-bold text-gray-800">
                    {language === 'en' ? 'Top Rated' : 'Najbolje ocenjeno'}
                  </span>
                </div>
              </div>
              
              <div className="absolute bottom-6 right-6 bg-blue-600/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-lg">
                <span className="text-sm font-semibold text-white">
                  {language === 'en' ? 'Instant Access' : 'Takojšen dostop'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
